//this code was written by following the instructions at https://developers.google.com/maps/documentation/javascript/tutorial


import React, { Component } from "react";

// Node module from https://www.npmjs.com/package/react-streetview
import ReactStreetview from "react-streetview";
import key from '../../keys.json';

//Uncomment the api-key at line (approximately) 29 to make a request
export default class GoogleMapsStreetView extends Component {
  constructor (props) {
    super(props)
    this.state = {
      streetViewPanoramaOptions : {
        //position: { lat: 59.403958, lng: 17.948827 },
        position: {
          lat: this.props.currentCoordinates.lat,
          lng: this.props.currentCoordinates.lng
        },
        pov: { heading: 100, pitch: 0 },
        zoom: 1,
        addressControl: false,
        linksControl: false,
        panControl: false,
        enableCloseButton: false,
        showRoadLabels: false,
        zoomControl: true,
        fullscreenControl: false
      }
    };


  }



  render() {
    const googleMapsApiKey = key.GOOGLE_API_KEY;

    // Find all available options here --> https://developers.google.com/maps/documentation/javascript/3.exp/reference#StreetViewPanoramaOptions
    
    return (
      <div //Style options for map
        style={{
          width: "100vw", //vw = viwport width which makes it take up 100% width of viewport (window)
          height: "100vh", //vh = viwport height which makes it take up 100% height of viewport (window)
          backgroundColor: "#eeeeee",
          position: "fixed-top",
         
        }}
      >
        
        
        <ReactStreetview
         apiKey={googleMapsApiKey}
          streetViewPanoramaOptions={this.state.streetViewPanoramaOptions}
        />


        
      </div>
    );
  }
}
